export const getHiddenAddress = (fullAddress: string) => {
  return fullAddress.split(',').slice(1, 2).join(' ');
};
